import React from "react";
import { ContactEmail, PolicyPage, PolicySection } from "./PolicyPage";

function Returns() {
  return (
    <PolicyPage
      title="Returns & Refunds Policy"
      intro="We want you to be satisfied with your purchase. This policy explains return eligibility, exclusions, and how refunds are handled."
    >
      <p className="policy-notice">
        Mandatory consumer rights remain available even where an item is otherwise
        listed as final sale or outside our voluntary return policy.
      </p>

      <PolicySection title="1. Standard return window">
        <p>
          Full-priced merchandise may be returned if you contact us within 14 days
          after delivery. Items must be unworn, unused, unaltered, undamaged, and sent
          back with all original tags, protective materials, accessories, and packaging.
          Proof of purchase is required.
        </p>
      </PolicySection>

      <PolicySection title="2. Items not eligible for a voluntary return">
        <ul>
          <li>items marked final sale or clearance at the time of purchase;</li>
          <li>personalized, engraved, made-to-order, or otherwise customized items;</li>
          <li>gift cards, if offered;</li>
          <li>items showing wear, alteration, damage, missing parts, or improper care; and</li>
          <li>pierced jewelry where a hygiene or tamper seal has been removed, if return is restricted by applicable health rules.</li>
        </ul>
        <p>
          An exclusion does not apply if the product is faulty, misdescribed, or must
          be accepted for return under applicable law.
        </p>
      </PolicySection>

      <PolicySection title="3. How to request a return">
        <ol>
          <li>Email <ContactEmail subject="Return request" /> with your order number, the item, and the reason for return.</li>
          <li>Wait for return authorization and instructions before sending anything. Unauthorized parcels may be delayed or refused.</li>
          <li>Pack the item securely and use a trackable service. Remove or cover earlier shipping labels.</li>
          <li>Send the parcel by the deadline in our instructions. International returns should reach the stated return location within 30 days after original delivery unless local law provides otherwise.</li>
        </ol>
        <p>
          Keep your shipping receipt. Unless the item is faulty, incorrect, or the law
          requires otherwise, you are responsible for return shipping and risk while it
          is in return transit.
        </p>
      </PolicySection>

      <PolicySection title="4. Inspection and refunds">
        <p>
          We inspect returned items. If approved, the eligible product price is refunded
          to the original payment method. Original delivery charges are not refundable
          unless the order was faulty, incorrect, cancelled under a statutory right, or
          applicable law requires a refund. Duties, taxes, and carrier charges paid to
          third parties may need to be reclaimed from those parties.
        </p>
        <p>
          We aim to process an approved refund within 10 business days after inspection.
          Your bank or payment provider may require additional time to post it. If an
          item fails the stated conditions, we will explain the decision and any lawful
          options available.
        </p>
      </PolicySection>

      <PolicySection title="5. Faulty, damaged, or incorrect items">
        <p>
          Inspect your order promptly. If an item arrives damaged, defective, or
          different from what you ordered, contact us as soon as reasonably possible
          with the order number and clear photographs of the item and packaging. Do not
          dispose of packaging until we respond. We will assess the issue and provide an
          appropriate repair, replacement, refund, or other remedy required by law.
        </p>
      </PolicySection>

      <PolicySection title="6. Exchanges">
        <p>
          We do not currently offer direct exchanges. To obtain another item or size,
          place a new order and return the eligible original item separately. Stock and
          pricing for the new order are not reserved while a return is in transit.
        </p>
      </PolicySection>

      <PolicySection title="7. Refused and unclaimed deliveries">
        <p>
          If a parcel is refused, unclaimed, or returned because of an incomplete
          address, we may deduct non-refundable carrier, return, duty, or handling costs
          from the refund where lawful. Contact us before refusing an order so we can
          advise on the best return method.
        </p>
      </PolicySection>

      <PolicySection title="8. Gifts and international returns">
        <p>
          Refunds are issued to the original payment method. Gift recipients should
          contact us for available options. International customers are responsible for
          completing accurate return customs documents; mark the parcel as returned
          merchandise where legally appropriate and follow the instructions supplied.
        </p>
      </PolicySection>
    </PolicyPage>
  );
}

export default Returns;

